<template>
  <div class="mobile-header">
    <div
      v-if="!initing && !isContactApp && isLogin"
      class="mobile-header-content"
    >
      <div v-if="userInfo.nickname" @click="handelLogOut">
        <span class="user">
          <img class="user-avatar" :src="userInfo.avatar" alt="" />
          <span class="user-name">{{ userInfo.nickname }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { login, logout } from "../utils/login";
import { mapState, mapGetters } from "vuex";
export default {
  name: "MobileHeader",

  data() {
    return {
      isContactApp: false,
    };
  },

  computed: {
    ...mapState(["initing", "userInfo"]),
    ...mapGetters(["isLogin"]),
  },

  methods: {
    handelLogOut() {
      // 退出登录
      logout();
      // 跳转登录
      login();
    },
  },
  mounted() {
    // 判断是否在芒果站内
    const isApp = /imgotv/i.test(window.navigator.userAgent);
    if (isApp) {
      this.isContactApp = true;
      return;
    }
    this.isContactApp = false;

    this.$nextTick(() => {
      window.onpageshow = function (event) {
        if (
          event.persisted ||
          (window.performance && window.performance.navigation.type === 2)
        ) {
          window.location.reload();
        }
      };
    });
  },
};
</script>
<style lang="less">
.mobile-header {
  display: none;
  color: @white;
  position: absolute;
  overflow: hidden;
  font-size: 14px;
  align-items: center;
  padding: 10px 20px;

  &-content {
    display: flex;
    align-items: center;

    .user {
      display: inline-block;

      &-avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        vertical-align: middle;
      }

      &-name {
        font-size: 14px;
        margin-left: 10px;
        vertical-align: middle;
        color: @white;
      }
    }
  }
}
</style>
